module.exports = __webpack_public_path__ + "static/media/building.c6699af0.svg";